import React from "react";

const RolesNPermissionsIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M21.4772 19.8901L22.9922 28.4161C23.0092 28.5165 22.9951 28.6197 22.9519 28.7119C22.9086 28.8041 22.8382 28.8808 22.7502 28.9319C22.6621 28.983 22.5605 29.006 22.459 28.9978C22.3576 28.9897 22.261 28.9507 22.1822 28.8861L18.6022 26.1991C18.4294 26.07 18.2195 26.0003 18.0037 26.0003C17.788 26.0003 17.5781 26.07 17.4052 26.1991L13.8192 28.8851C13.7406 28.9496 13.6441 28.9885 13.5427 28.9967C13.4414 29.0049 13.3399 28.982 13.2519 28.931C13.1639 28.88 13.0935 28.8035 13.0502 28.7115C13.0068 28.6195 12.9925 28.5165 13.0092 28.4161L14.5232 19.8901"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M18 21C21.3137 21 24 18.3137 24 15C24 11.6863 21.3137 9 18 9C14.6863 9 12 11.6863 12 15C12 18.3137 14.6863 21 18 21Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default RolesNPermissionsIcon;
